<template>
  <div class="l-content">
    <div class="col-xs-16 col-xs-offset-1">
      <nav class="footer-nav row">
        <router-link :class="[nextRoute === undefined ? 'footer-nav__button--fullwidth' : '']" v-if="prevRoute" :to="{name: prevRoute}" class="footer-nav__button footer-nav__button--prev">
          <div class="footer-nav__arrow footer-nav__arrow--prev">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11 22" enable-background="new 0 0 11 22" xml:space="preserve">
            <polygon points="1.5,22 0,20.6 8.3,11 0,1.4 1.5,0 11,11 "/>
            </svg>
          </div>
          <div class="footer-nav__copy">
            <div class="footer-nav__title t-chartbody">{{$t('nav.Prev')}}</div>
            <div class="footer-nav__text">{{$t(`nav.${prevRoute}`)}}</div>
          </div>
        </router-link>
        <router-link :class="[prevRoute === undefined ? 'footer-nav__button--fullwidth' : '']" v-if="nextRoute" :to="{name: nextRoute}" class="footer-nav__button footer-nav__button--next">
          <div class="footer-nav__copy">
            <div class="footer-nav__title t-chartbody">{{$t('nav.Next')}}</div>
            <div class="footer-nav__text">{{$t(`nav.${nextRoute}`)}}</div>
          </div>
          <div class="footer-nav__arrow footer-nav__arrow--next">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11 22" enable-background="new 0 0 11 22" xml:space="preserve">
            <polygon points="1.5,22 0,20.6 8.3,11 0,1.4 1.5,0 11,11 "/>
            </svg>
          </div>
        </router-link>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterNav',
  props: {
    nextRoute: String,
    prevRoute: String
  }
}
</script>
<style lang="scss" scoped>
  @import '~@/scss/vars';
  .footer-nav {
    display: flex;
    flex-flow: row nowrap;
    border-radius: 8px;
    background-color: $white;
    box-shadow: 0px 18px 24px 0px rgba(26, 26, 26, 0.07);
    margin-bottom: 40px;
    &__button {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 84px;
      text-decoration: none;
      &.footer-nav__button--fullwidth {
        width: 100%;
      }
      @media (min-width: 768px) {
        width: 50%;
        height: 102px;
      }
      &--prev {
        flex-grow: initial;
        border-right: 1px solid #e7e6e6;
        &.footer-nav__button--fullwidth {
          border-right: none;
          & .footer-nav__copy {
            display: block;
          }
        }
        & .footer-nav__copy {
          display: none;
          @media (min-width: 768px) {
            display: block;
          }
        }
      }
      &--next {
        flex-grow: 1;
        justify-content: flex-end;
        text-align: right;
        padding-left: 20px;
        min-width: 0;
      }
    }
    &__copy {
      overflow: hidden;
    }
    &__title {
      // font-size: 22px;
      // font-family: $font-primary;
      // font-weight: 500;
      color: $green-light;
      // line-height: 1.818;
    }
    &__text {
      font-size: 15px;
      font-family: $font-primary;
      font-weight: 500;
      color: $grey;
      line-height: 1.667;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    &__arrow {
      padding-left: 30px;
      padding-right: 30px;
      svg {
        width: 11px;
        height: 22px;
        @media(min-width: 768px) {
          width: 11px;
          height: 22px;
        }
        polygon {
          fill: #b5b6b8;
        }
      }
      &--prev {
        transform: rotate(180deg);
      }
      &--next {
        transform: translate(0,3px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterNav.vue